import { render, staticRenderFns } from "./SiteSetting.vue?vue&type=template&id=5f8da1d9&scoped=true&"
import script from "./SiteSetting.vue?vue&type=script&lang=js&"
export * from "./SiteSetting.vue?vue&type=script&lang=js&"
import style0 from "./SiteSetting.vue?vue&type=style&index=0&id=5f8da1d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8da1d9",
  null
  
)

export default component.exports